import { render, staticRenderFns } from "./development.vue?vue&type=template&id=b7e4066c&scoped=true&"
import script from "./development.vue?vue&type=script&lang=js&"
export * from "./development.vue?vue&type=script&lang=js&"
import style0 from "./development.vue?vue&type=style&index=0&id=b7e4066c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e4066c",
  null
  
)

export default component.exports